export default {
  'FrictionlessBooking.header': {
    en: 'Frictionless Booking',
    fr: 'Réservation sans friction',
  },
};
